
import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useTranslation } from 'react-i18next';

interface TermsAlertProps {
  isPage1: boolean;
  isTermsAccepted: boolean;
}

export const TermsAlert: React.FC<TermsAlertProps> = ({ isPage1, isTermsAccepted }) => {
  const { t } = useTranslation();
  if (!isPage1 || isTermsAccepted) return null;
  
  return (
    <Alert className="mt-4 mb-2 bg-amber-50 border-amber-200">
      <AlertDescription>
        {t('form.termsAlert')}
      </AlertDescription>
    </Alert>
  );
};

interface AbsentStudentAlertProps {
  isPage2: boolean;
  isStudentAbsent: boolean;
}

export const AbsentStudentAlert: React.FC<AbsentStudentAlertProps> = ({ isPage2, isStudentAbsent }) => {
  const { t } = useTranslation();
  if (!isPage2 || !isStudentAbsent) return null;
  
  return (
    <Alert className="mt-4 mb-2 bg-blue-50 border-blue-200">
      <AlertDescription>
        {t('form.absentAlert')}
      </AlertDescription>
    </Alert>
  );
};
